"use strict";
/**
 * This code was AUTOGENERATED using the kinobi library.
 * Please DO NOT EDIT THIS FILE, instead use visitors
 * to add features, then rerun kinobi to update it.
 *
 * @see https://github.com/metaplex-foundation/kinobi
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.getMigrationTypeSerializer = exports.MigrationType = void 0;
const serializers_1 = require("@metaplex-foundation/umi/serializers");
var MigrationType;
(function (MigrationType) {
    MigrationType[MigrationType["CollectionV1"] = 0] = "CollectionV1";
    MigrationType[MigrationType["ProgrammableV1"] = 1] = "ProgrammableV1";
})(MigrationType = exports.MigrationType || (exports.MigrationType = {}));
function getMigrationTypeSerializer() {
    return (0, serializers_1.scalarEnum)(MigrationType, {
        description: 'MigrationType',
    });
}
exports.getMigrationTypeSerializer = getMigrationTypeSerializer;
//# sourceMappingURL=migrationType.js.map